import { LinkifyIt } from 'linkify-it';
import React, { type JSX } from 'react';
import ReactLinkify from 'react-linkify';
import { phoneNumbers } from '@guuru/markdown-common';
import anchor from './anchor';
import hyperlinkValidator from './hyperlinkValidator';

const componentDecorator = (href: string, text: string, key: React.Key) =>
  anchor(href, text, key);

const matchDecorator = (textToMatch: string) => {
  const linkify = new LinkifyIt({ fuzzyLink: true });
  linkify.add('[', { validate: hyperlinkValidator });

  phoneNumbers.forEach(({ prefix, options }) => {
    linkify.add(prefix, options);
  });

  return linkify.match(textToMatch);
};

interface LinkifyProps {
  text?: string | JSX.Element;
}

const Linkify = function ({ text }: LinkifyProps) {
  return (
    <ReactLinkify
      componentDecorator={componentDecorator}
      matchDecorator={matchDecorator}
    >
      {text}
    </ReactLinkify>
  );
};

export default Linkify;
